<script>
import api from '@/helpers/api'
import stepHelper from './step-helper'
export default {
  name: 'form.form.settings',
  props: {
    value: { type: Object, default: () => {} }
  },
  data: () => ({
    form: {}
  }),
  mixins: [stepHelper],
  methods: {
    validate () {
      return this.__validateForm()
    }
  },
  validations () {
    return {
      form: {}
    }
  }
}
</script>
<template>
  <div>
    <b-form-group
      label="EU Vat Exempt"
      label-for="eu_vat_exempt"
      label-cols-sm="6"
      label-cols-lg="4"
      class="align-items-center"
    >
      <template v-slot:label>
        <div class="d-flex align-items-center">
          EU Vat Exempt
          <i
            class="bx bx-info-circle mx-4 font-size-20"
            id="info_eu_vat_exempt"
          ></i>
        </div>
      </template>
      <b-form-checkbox
        switch
        size="lg"
        id="eu_vat_exempt"
        v-model="form.eu_vat_exempt"
        name="eu_vat_exempt"
      ></b-form-checkbox>
      <b-tooltip target="info_eu_vat_exempt" triggers="hover" placement="right"
        >Enable this option if the customer's Headquarters is located in
        EU-Country.</b-tooltip
      >
    </b-form-group>
    <b-form-group
      label-for="send_digital_invoice"
      label-cols-sm="6"
      label-cols-lg="4"
      class="d-flex align-items-center"
    >
      <template v-slot:label>
        <div class="d-flex align-items-center pointer">
          Send Digital Invoice
          <i
            class="bx bx-info-circle mx-4 font-size-20"
            id="info_send_digital_invoice"
          ></i>
        </div>
      </template>
      <b-form-checkbox
        switch
        size="lg"
        id="send_digital_invoice"
        v-model="form.send_digital_invoice"
        name="send_digital_invoice"
        inline
      ></b-form-checkbox>
      <b-tooltip
        target="info_send_digital_invoice"
        triggers="hover"
        placement="right"
        >Enable this option if the customer's wants to receive a digital
        invoice.</b-tooltip
      >
    </b-form-group>
    <b-form-group
      label="Billing Email"
      label-for="invoice_emails"
      label-cols-sm="6"
      label-cols-lg="4"
      class="d-flex align-items-center"
      v-if="form.send_digital_invoice"
    >
      <b-form-input
        id="invoice_emails"
        v-model="form.billing_email"
        type="text"
        required
        autocomplete="invoice_emails"
        placeholder="ex. invoice@company.com;accounting@company.com"
        :style="{ maxWidth: '800px' }"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      v-if="false"
      label="Payment Term"
      label-for="payment_term"
      label-cols-sm="6"
      label-cols-lg="4"
      class="d-flex align-items-center"
    >
      <app-payment-term-select v-model="form.payment_term_id" />
    </b-form-group>
    <b-form-group
      label-for="send_digital_invoice"
      label-cols-sm="6"
      label-cols-lg="4"
      class="d-flex align-items-center"
    >
      <template v-slot:label>
        <div class="d-flex align-items-center pointer">
          Structured Reference
          <i
            class="bx bx-info-circle mx-4 font-size-20"
            id="info_use_structured_reference"
          ></i>
        </div>
      </template>
      <b-form-checkbox
        switch
        size="lg"
        id="use_structured_reference"
        v-model="form.use_structured_reference"
        name="use_structured_reference"
        inline
      ></b-form-checkbox>
      <b-tooltip
        target="info_use_structured_reference"
        triggers="hover"
        placement="right"
        >Use Structured Reference on Invoice.</b-tooltip
      >
    </b-form-group>
  </div>
</template>
